import supabase from "./supabase";

export async function addGrade(
  token: string,
  score: number,
  gradeLabel: string,
  gradeType: string
) {
  try {
    // Get the JWT token from localStorage or wherever you store it
    // Get auth token
    const {
      data: { session },
    } = await supabase.auth.getSession();
    const jwtToken = session?.access_token;

    const response = await fetch(
      `${import.meta.env.VITE_API_BASE_URL}/lti/grades?ltik=${token}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify({ score, gradeLabel, gradeType }),
      }
    );

    // Check if response is ok
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Check if response has content
    const text = await response.text();
    if (!text) {
      return { success: true, message: "Grade submitted successfully" };
    }

    // Try to parse as JSON
    try {
      const data = JSON.parse(text);
      return data;
    } catch (parseError) {
      console.error("Failed to parse JSON response:", parseError);
      return { error: "Invalid response from server", rawResponse: text };
    }
  } catch (error) {
    console.error("Error in addGrade:", error);
    return { error: error.message };
  }
}
